import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getStoredUser, isAllowedRole } from "../lib/auth";

function ProtectedRoute({ roles = [] }) {
  const location = useLocation();
  const user = getStoredUser();

  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!isAllowedRole(user, roles)) {
    const fallbackPath =
      user.role === "student" ? "/exam" : user.role === "admin" ? "/admin" : "/dashboard";
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
